import { Injectable } from '@angular/core';
import { AuditReportModel } from '@app/core/Models/report/audit-report/audit-report';
import { AuditReportService } from '@app/core/Services/report/audit-report.service';
import { Action, State, StateContext } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { tap } from 'rxjs/operators';
import { GetAllAuditDetails, GetAudit, GetAuditBasedonId, GetAuditReportDetailsByType, SaveAuditDetails, SaveAuditReportDetails } from './audit-report.action';

export class AuditReportStateInfo {
  auditDetails?: AuditReportModel 
  audits?: [];
  auditId?: Guid;
  isSuccess?: any;
  reports?: any;
  reportDetails?: any;
}

@State<AuditReportStateInfo>({
  name: 'AuditReport',
  defaults: {
    audits: [],
    isSuccess: true
  },
})
@Injectable()
export class AuditReportState {
  constructor(private auditReportService: AuditReportService) {}

  @Action(GetAudit)
  getAllAuditGetAudit(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: GetAudit
  ) {
    return this.auditReportService.getAudit()
      .pipe(
        tap((res) => {
          patchState({
            auditDetails: res,
          });
        })
      );
    }

  @Action(GetAllAuditDetails)
  getAllAuditGetAllAuditDetails(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: GetAllAuditDetails
  ) {
    return this.auditReportService.getAllAuditDetails()
      .pipe(
        tap((res) => {
          patchState({
            audits: res,
          });
        })
      );
  }

  @Action(GetAuditBasedonId)
  GetAuditBasedonId(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: GetAuditBasedonId
  ) {
    return this.auditReportService.getAuditBasedonId(action.auditId)
      .pipe(
        tap((res) => {
          patchState({
            auditDetails: res,
          });
        })
      );
  }

  @Action(SaveAuditDetails)
  SaveAuditDetails(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: SaveAuditDetails
  ) {
    return this.auditReportService.saveAuditDetails(action.auditDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(GetAuditReportDetailsByType)
  GetAuditReportDetailsByType(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: GetAuditReportDetailsByType
  ) {
    return this.auditReportService.getAuditReportDetailsByType(action.type)
      .pipe(
        tap((res) => {
          patchState({
            reportDetails: res,
          });
        })
      );
  }

  @Action(SaveAuditReportDetails)
  SaveAuditReportDetails(
    { patchState }: StateContext<AuditReportStateInfo>,
    action: SaveAuditReportDetails
  ) {
    return this.auditReportService.saveAuditReportDetails(action.reportDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }
}
